import { DictionaryWaterOriginAutocomplete } from '../../models';
import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

export function useDictionaryWaterOrigins() {
  return useAutocompleteSource<DictionaryWaterOriginAutocomplete>({
    url: EvidenceAPI.DICTIONARY_WATER_ORIGINS + '/autocomplete',
  });
}
